import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ReactComponent as PencilIcon } from "@/assets/images/mdi-pencil.svg";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelectedProjectInfo } from "../../hooks/useTabStore";
import { useUpdateProjectGroupsItemSheetLatest } from "@/libs/react-query/hooks/useItemsheetsQuery";

type Props = {
  defaultTitle: string;
};

export default function EstimateTitle({ defaultTitle }: Props) {
  const { group_id = "" } = useParams();

  const [title, setTitle] = useState(defaultTitle);
  const [isEditing, setIsEditing] = useState(false);
  const selectedProjectInfo = useSelectedProjectInfo();

  const { mutate } = useUpdateProjectGroupsItemSheetLatest(
    group_id,
    selectedProjectInfo?.latestSheetId ?? ""
  );

  const handleSave = () => {
    if (!selectedProjectInfo?.latestSheetId) return;

    const { projectId, originalId, projectType } = selectedProjectInfo;

    mutate({
      title,
      original_id: originalId,
      project_id: projectId,
      project_type: projectType,
    });

    setIsEditing(false);
  };

  useEffect(() => {
    if (!isEditing) {
      setTitle(defaultTitle);
    }
  }, [isEditing]);

  if (isEditing) {
    return (
      <div className="h-10 inline-flex items-center gap-2 text-sm text-gray-A font-semibold">
        <Input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="h-7 w-96 border border-dark-red rounded text-sm text-gray-A"
          placeholder="산출내역서 이름"
        />
        <Button
          size="sm"
          onClick={() => setIsEditing(false)}
          className="text-[10px] text-gray-A bg-gray-E border-gray-D hover:bg-gray-E/80 hover:text-gray-A/80"
        >
          취소
        </Button>
        <Button
          size="sm"
          onClick={handleSave}
          className="text-[10px] bg-dark-red text-white hover:bg-dark-red/80 hover:text-white/80"
        >
          저장
        </Button>
      </div>
    );
  }

  return (
    <div className="h-10 inline-flex items-center gap-2 text-sm text-gray-A font-semibold">
      <span>{defaultTitle}</span>
      <PencilIcon
        className="size-3 text-gray-B cursor-pointer"
        onClick={() => setIsEditing(true)}
      />
    </div>
  );
}
